import "./Card.css";

function Card({ text, icon, variant, onClick, x, y }) {
  if (variant === "small") {
    return (
      <div
        className="CardBody"
        style={{ transform: `translate(${x}px, ${y}px)` }}
      >
        <span className="iconContainer">{icon}</span>
        <span className="TextContent"> {text} </span>
      </div>
    );
  }
  if (variant === "fullWidth") {
    return (
      <div
        className="CardBody Long"
        style={{ transform: `translate(${x}px, ${y}px)` }}
      >
        <span className="iconContainer">{icon}</span>
        <span className="TextContent"> {text} </span>
      </div>
    );
  }
}

export default Card;
